import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel", "summary"]
  static values = { open: Boolean }

  connect() {
    this.render()
  }

  toggle() {
    this.openValue = !this.openValue
    this.render()
  }

  render() {
    this.panelTarget.hidden = !this.openValue
    this.buttonTarget.setAttribute("aria-expanded", String(this.openValue))
    if (this.hasSummaryTarget) this.summaryTarget.hidden = this.openValue
  }
}
